import { useState, type ReactNode } from "react";
import { createRouteBodyRetention, RouteBodyRetentionContext } from "#route-body-retention-context";

/** Keeps an explicitly open overlay alive while a retained review loses screen focus. */
export function RouteBodyRetentionProvider({ children }: { children: ReactNode }) {
  const [retention] = useState(createRouteBodyRetention);
  return <RouteBodyRetentionContext value={retention}>{children}</RouteBodyRetentionContext>;
}
